import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { SearchBar, Pagination } from "../../components";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AddModalLiterature from "../Modals/AddModalLiterature";
import {
  fetchDataLiterature,
  setPage,
} from "../../store/slices/apiLiteratureSlice";
import EditModalLiterature from "../Modals/EditModal/EditModalLiterature";
import InfoModal from "../Modals/InfoModal/InfoModal";
import { openModalDelete } from "../../store/slices/deleteModalLiteratureSlice";
import DeleteModalLiterature from "../Modals/DeleteModal/DeleteModalLiterature";
import { openModal, closeModal } from "../../store/slices/editModalSlice";

const TableLiterature = () => {
  const dispatch = useDispatch();

  const backendBaseUrl = "https://back2.autoshkollaime.com";
  const dataLiterature = useSelector((state) => state.apiLiterature.data);
  const currentPage = useSelector((state) => state.apiLiterature.currentPage);
  const totalCount = useSelector((state) => state.apiLiterature.totalCount);

  const [searchInput, setSearchInput] = useState("");
  const prevSearchRef = useRef("");
  const editModalState = useSelector((state) => state.editModalLiterature);

  const handleCloseModal = () => {
    dispatch(closeModal());
  };
  const handleEditItem = (id) => {
    dispatch(openModal(id));
  };
  const handleDeleteItem = (id) => {
    dispatch(openModalDelete(id));
  };

  function getYesNoTextFromBoolean(value) {
    return value ? "Po" : "Jo";
  }

  useEffect(() => {
    const pageToUse =
      prevSearchRef.current !== searchInput ? 1 : currentPage;
  
    if (prevSearchRef.current !== searchInput) {
      dispatch(setPage(1)); // Reset page in Redux slice managing literature
      prevSearchRef.current = searchInput;
    }
  
    dispatch(fetchDataLiterature({ page: pageToUse, searchQuery: searchInput }));
  }, [dispatch, currentPage, searchInput]);
  

  const handleSearchInputChange = (e) => {
    setSearchInput(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    dispatch(
      fetchDataLiterature({ page: currentPage, searchQuery: searchInput })
    );
  };

  const handlePageChange = (page) => {
    dispatch(setPage(page));
  };

  return (
    <div className="p-3">
      <div className="flex items-center justify-between pb-4 bg-white dark:bg-gray-900">
        <SearchBar
          searchInput={searchInput}
          handleSearchInputChange={handleSearchInputChange}
          handleSearchSubmit={handleSearchSubmit}
        />
        <div>
          <button className="text-blue-500 mx-2" alt="you can edit here">
            <AddModalLiterature
              title="Shto një literaturë"
              submitButtonText="Shto literaturën"
              inputLabel2="Zgjedh kategorinë"
              premiumStatus="A eshte premium"
            />
          </button>
        </div>
      </div>
      <div
        className="relative overflow-x-auto shadow-md sm:rounded-lg"
        style={{ borderRadius: 1 }}
      >
        <div className="hidden sm:block">
          <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400 table-fixed">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="px-6 py-3">
                  Emri i Literaturës
                </th>
                <th scope="col" className="px-6 py-3 w-40">
                  Kategoria
                </th>
                <th scope="col" className="px-6 py-3 w-28">
                  Premium
                </th>
                <th scope="col" className="px-6 py-3 w-32">
                  Ikona
                </th>
                <th scope="col" className="px-6 py-3 w-80">
                  Pershkrimi
                </th>
                <th scope="col" className="px-6 py-3 w-40">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {dataLiterature?.data?.map((item) => (
                <tr
                  key={item.id}
                  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                >
                  <td
                    className="px-2 py-2 font-medium text-gray-900 whitespace-nowrap dark:text-white truncate max-w-[176px]"
                    title={item.name}
                  >
                    {item.name}
                  </td>
                  <td className="px-6 py-4 truncate max-w-[160px]">
                    {item.categoryName}
                  </td>
                  <td className="px-6 py-4 truncate max-w-[80px]">
                    {getYesNoTextFromBoolean(item.isPremium)}
                  </td>
                  <td className="px-6 py-4 truncate max-w-[120px]">
                    <a
                      href={`${backendBaseUrl}/${item.icon}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={`${backendBaseUrl}/${item.icon}`}
                        alt="Question"
                        className="w-14 h-14 object-cover"
                      />
                    </a>
                  </td>
                  <td
                    className="px-6 py-4 truncate max-w-[320px]"
                    title={item.description}
                  >
                    {item.description}
                  </td>
                  <td className="px-6 py-4 w-40">
                    <button className="text-blue-500 mr-2">
                      <InfoModal
                        title="Info rreth kategorise"
                        onCancel={handleCloseModal}
                        inputLabel1="Lloji i kategorisë"
                        inputLabel2="Emri 1"
                        inputLabel4="Emri 2"
                      />
                    </button>
                    <button
                      className="text-sucess mx-1"
                      onClick={() => handleEditItem(item.id)}
                    >
                      <EditModalLiterature
                        id={item.id}
                        onCancel={handleCloseModal}
                        title="Edito një literaturë"
                        submitButtonText="Edito literaturën"
                        questionsName="Emri literaturës"
                        CategoryName="Kategorisa e literaturës"
                        premiumStatus="A eshte premium"
                        isOpen={editModalState[item.id] === true}
                        onSuccess={() =>
                          dispatch(
                            fetchDataLiterature({
                              page: currentPage,
                              searchQuery: searchInput,
                            })
                          )
                        }
                      />
                    </button>
                    <button
                      className="text-danger mx-1"
                      onClick={() => handleDeleteItem(item.id)}
                    >
                      <DeleteModalLiterature
                        id={item.id}
                        onDeleted={() =>
                          dispatch(
                            fetchDataLiterature({
                              page: currentPage,
                              searchQuery: searchInput,
                            })
                          )
                        }
                        onCancel={handleCloseModal}
                      />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="block sm:hidden space-y-4">
          {dataLiterature?.data?.map((item) => (
            <div
              key={item.id}
              className="bg-white shadow rounded-lg p-4 text-sm space-y-2"
            >
              <p>
                <strong>Emri i Literaturës:</strong> {item.name}
              </p>
              <p>
                <strong>Kategoria:</strong> {item.categoryName}
              </p>
              <p>
                <strong>Premium:</strong>{" "}
                {getYesNoTextFromBoolean(item.isPremium)}
              </p>
              <p>
                <strong>Ikona:</strong>
                <a
                  href={`${backendBaseUrl}/${item.icon}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={`${backendBaseUrl}/${item.icon}`}
                    alt="Ikona"
                    className="w-14 h-14 object-cover mt-2"
                  />
                </a>
              </p>
              <p>
                <strong>Përshkrimi:</strong> {item.description}
              </p>
              <div className="flex flex-wrap gap-2 pt-2">
                <InfoModal
                  title="Info rreth kategorisë"
                  onCancel={handleCloseModal}
                  inputLabel1="Lloji i kategorisë"
                  inputLabel2="Emri 1"
                  inputLabel4="Emri 2"
                />
                <EditModalLiterature
                  id={item.id}
                  onCancel={handleCloseModal}
                  title="Edito një literaturë"
                  submitButtonText="Edito literaturën"
                  questionsName="Emri literaturës"
                  CategoryName="Kategorisa e literaturës"
                  premiumStatus="A eshte premium"
                  isOpen={editModalState[item.id] === true}
                  onSuccess={() =>
                    dispatch(
                      fetchDataLiterature({
                        page: currentPage,
                        searchQuery: searchInput,
                      })
                    )
                  }
                />
                <DeleteModalLiterature
                  id={item.id}
                  onCancel={handleCloseModal}
                />
              </div>
            </div>
          ))}
        </div>

        <Pagination
          currentPage={currentPage}
          totalCount={totalCount}
          onPageChange={handlePageChange}
        />
      </div>
      <ToastContainer />
    </div>
  );
};

export default TableLiterature;
